<template>
  <ui-dialog
    :show="isOpen"
    persistent
    scrollable
    max-width="623"
    @input="close"
  >
    <template #header>
      <h3>
        {{ $t("message.facilityCreate.dialog.inGoogle.title") }}
      </h3>
    </template>
    <template #default>
      <p class="description" v-if="mix">
        {{ $t(`message.facilityCreate.dialog.inGoogle.descriptionTop.mixAll`) }}
      </p>
      <p class="description" v-else-if="mixWithAndWithoutOwner">
        {{
          $t(
            `message.facilityCreate.dialog.inGoogle.descriptionTop.mixWithAndWithoutOwner`
          )
        }}
      </p>
      <p class="description" v-else-if="existsInAccount">
        {{
          $t(
            `message.facilityCreate.dialog.inGoogle.descriptionTop.onlyExistsInAccount`
          )
        }}
      </p>
      <h4>
        {{ $t("message.facilityCreate.dialog.inGoogle.choiceHeader") }}
      </h4>
      <SingleSearchResult
        v-for="result in results"
        :key="result.place_id"
        :result="result"
        :selected="
          !!selectedResult && selectedResult.place_id === result.place_id
        "
        @select="selectResult"
      />
      <p
        class="description mt-4"
        v-if="
          selectedResult &&
            selectedResult.action === FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT
        "
      >
        {{
          $t(
            `message.facilityCreate.dialog.inGoogle.${FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT}.descriptionBottom`,
            {
              account: selectedResult && selectedResult.gmb_email,
              profile: selectedResult && selectedResult.gmb_profile_name
            }
          )
        }}
      </p>
    </template>
    <template #actions>
      <div class="actions">
        <ui-button
          v-if="selectedResult && selectedResult.action"
          color="primary"
          class="ml-3"
          @click="performAction"
        >
          {{
            $t(
              `message.facilityCreate.dialog.inGoogle.${selectedResult.action}.applyBtn`
            )
          }}
        </ui-button>
        <div class="create-duplicate">
          <p class="mb-0">
            {{ $t("message.common.or").toLowerCase() }}
          </p>
          <button class="create-duplicate__btn" @click="createDuplicate">
            {{ $t("message.facilityCreate.dialog.inGoogle.createNewFacility") }}
          </button>
        </div>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import SingleSearchResult from "@/components/FacilityCreate/InGoogle/SingleSearchResult.vue";
import { FACILITY_CREATE_ACTION } from "@/enums/gmb-search-type";

export default {
  name: "InGoogleDialog",
  components: { SingleSearchResult },
  data() {
    return {
      FACILITY_CREATE_ACTION,
      selectedResult: null
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    results: {
      type: Array,
      required: true
    }
  },
  computed: {
    existsInAccount() {
      return this.results.some(
        result => result.action === FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT
      );
    },
    mixWithAndWithoutOwner() {
      return this.results.some(result =>
        [
          FACILITY_CREATE_ACTION.WITH_OWNER,
          FACILITY_CREATE_ACTION.WITHOUT_OWNER
        ].includes(result.action)
      );
    },
    mix() {
      return this.existsInAccount && this.mixWithAndWithoutOwner;
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.results && this.results.length) {
        this.selectedResult = this.results[0];
      } else {
        this.selectedResult = null;
      }
    }
  },
  methods: {
    selectResult(result) {
      this.selectedResult = result;
    },

    close() {
      this.$emit("close");
    },

    createDuplicate() {
      this.$emit("createDuplicate");
      this.close();
    },

    performAction() {
      switch (this.selectedResult.action) {
        case FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT:
          this.$emit("importFacility", this.selectedResult.gmb_location_name);
          break;
        case FACILITY_CREATE_ACTION.WITHOUT_OWNER:
          this.$emit("createFacility", {
            placeId: this.selectedResult.place_id
          });
          break;
        case FACILITY_CREATE_ACTION.WITH_OWNER:
          this.$emit("goToOwnershipUrl", this.selectedResult.ownership_url);
          break;
        default:
          this.close();
      }
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  line-height: 36px;
}

h4 {
  @include font-size(16px);
  font-weight: 700;
  color: $text;
}

p {
  color: $text;
  @include font-size(16px);
  font-weight: 500;
  text-align: center;
}

.description {
  text-align: left;
}

.actions {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}

.create-duplicate {
  display: flex;
  align-items: center;
  margin-top: $spacing * 2;

  p,
  &__btn {
    @include font-size(14px);
  }

  &__btn {
    font-weight: 600;
    display: block;
    margin-left: $spacing;
    color: $primary;
    text-decoration: underline;
    cursor: pointer;
    transition: 0.1s background ease-in-out;
    padding: $spacing * 0.5 $spacing;
    background: transparent;
    border-radius: 4px;

    &:hover {
      background: rgba($primary, 0.1);
    }
  }
}
</style>
